import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { Box, Stack, TextField } from '@mui/material';
import { IoClose } from "react-icons/io5";

export default function UpdateDialog(props) {

    // console.log("propsforpayment",props);


    return (
        <React.Fragment>

            <Dialog
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth
            >
                <Box sx={{ position: 'absolute', top: 5, right: 5, fontSize: "25px", cursor: "pointer" }} onClick={()=>props.handleClose()}>
                    <IoClose />
                </Box>
                <DialogContent>
                    <Stack>
                        <table>
                            <tr>
                                <td style={{ padding: '10px' }}><strong>SH Quoted Amount</strong></td>
                                <td style={{ padding: '10px' }}>{props.data ? props.data.sh_amount ? props.data.sh_amount : 0 : "N/A"}</td>
                            </tr>
                            <tr>
                                <td style={{ padding: '10px' }}><strong>Updated Amount</strong></td>
                                <td style={{ padding: '10px' }}>
                                    <TextField
                                        size='small'
                                        value={props.updatedData ? props.updatedData[props.data ? props.data.user_id ? props.data.user_id : 0 : 0] : 0}
                                        onChange={(e) => props.handleUpdateData(props.data, e.target.value)  }
                                    /></td>
                            </tr>
                        </table>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Stack direction="row" justifyContent="center" sx={{width:"100%"}}>
                        <Button variant='contained' color='secondary'  onClick={props.handleClose}>
                            Confirm
                        </Button>
                    </Stack>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
